import { NotFoundPage } from '@scoring/ui';
import { Route } from 'react-router';
import { lazyPage } from '../../shell/lazyPage';

const JudgeLayout = lazyPage(() => import('./judging/JudgeLayout.tsx'), 'JudgeLayout');
const JudgeImpersonationPage = lazyPage(
    () => import('./judging/entry/JudgeImpersonationPage.tsx'),
    'JudgeImpersonationPage'
);
const JudgePanelRoot = lazyPage(() => import('./judging/JudgePanelRoot.tsx'), 'JudgePanelRoot');

export const judgeRoutes = (
    <Route path="judge" lazy={JudgeLayout}>
        <Route index lazy={JudgePanelRoot} />
        <Route path="impersonate" lazy={JudgeImpersonationPage} />
        <Route path=":externalId" lazy={JudgePanelRoot} />
        <Route path=":externalId/:competitionExternalId/:categoryExternalId" lazy={JudgePanelRoot} />
        <Route
            path=":externalId/:competitionExternalId/:categoryExternalId/:phaseExternalId/:heatExternalId"
            lazy={JudgePanelRoot}
        />
        <Route path="*" element={<NotFoundPage />} />
    </Route>
);
